import './FiRearwallDialog.scss';

import * as angular from 'angular';
import { FiFurnitureService } from './../fiFurniture/FiFurnitureService';

import { Component } from '../Component';

@Component({
    controllerAs: 'vm',
    template: require('./FiRearwallDialog.html'),
    bindings: {

    },
})
export class FiRearwallDialog {
    static $inject = [
        '$mdDialog',
        'fiFurnitureService',
    ];


    constructor(
        private $mdDialog: angular.material.IDialogService,
        private fs: FiFurnitureService,
    ) {
        //
    }

    $onInit() {
        //
    }

    close() {
        this.$mdDialog.cancel();
    }

    accept() {
        this.fs.furniture.additional.option_1 = false;
        this.$mdDialog.cancel();
    }

}